import { ThemeEvents } from '@theme/events';

/**
 * A bar fixed to the bottom of the screen on mobile that adds the current product to the cart.
 * It shows while the main buy buttons are out of view and submits through the main add to cart button,
 * so the selected variant, cart drawer and error handling all behave as they do for that button.
 */
class StickyAddToCart extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    this.section = this.closest('.shopify-section');
    if (!this.section) return;

    this.addEventListener('click', this.#onClick);
    this.section.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);

    const buyButtons = this.section.querySelector('.product-details .buy-buttons-block');
    if (!buyButtons) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const visible = !entry?.isIntersecting;
      this.toggleAttribute('data-visible', visible);
      this.setAttribute('aria-hidden', String(!visible));
    });
    this.#observer.observe(buyButtons);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.removeEventListener('click', this.#onClick);
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /** @returns {HTMLButtonElement | null | undefined} */
  get mainButton() {
    return this.section?.querySelector('.product-details add-to-cart-component button[name="add"]');
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.sticky-atc__button')) return;
    this.mainButton?.click();
  };

  /** @param {import('@theme/events').VariantUpdateEvent} event */
  #onVariantUpdate = (event) => {
    const newContent = event.detail.data.html?.querySelector('.sticky-atc__content');
    const content = this.querySelector('.sticky-atc__content');

    if (newContent && content) content.replaceWith(newContent);
  };
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
